import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useKatpackStore = create(
  persist(
    (set) => ({
      instance: {
        jwtToken: null,
        refreshToken: null,
        apiBaseUrl: null,
        userSub: null, // wallet address from JWT sub
        // Katbot session — NOT persisted to localStorage (see partialize below)
        katbotToken: null,
        katbotUser: null,
      },
      _hasHydrated: false,
      setHasHydrated: (state) => set({ _hasHydrated: state }),

      setJwtToken: (token) =>
        set((state) => ({
          instance: { ...state.instance, jwtToken: token },
        })),
      clearJwtToken: () =>
        set((state) => ({
          instance: { ...state.instance, jwtToken: null },
        })),
      setRefreshToken: (token) =>
        set((state) => ({
          instance: { ...state.instance, refreshToken: token },
        })),
      clearRefreshToken: () =>
        set((state) => ({
          instance: { ...state.instance, refreshToken: null },
        })),
      clearAuthTokens: () =>
        set((state) => ({
          instance: { ...state.instance, jwtToken: null, refreshToken: null },
        })),
      setApiBaseUrl: (url) =>
        set((state) => ({
          instance: { ...state.instance, apiBaseUrl: url },
        })),
      setUserSub: (sub) =>
        set((state) => ({
          instance: { ...state.instance, userSub: sub },
        })),
      clearUserSub: () =>
        set((state) => ({
          instance: { ...state.instance, userSub: null },
        })),

      // Katbot session actions (token stays in memory only — not persisted)
      setKatbotToken: (token) =>
        set((state) => ({
          instance: { ...state.instance, katbotToken: token },
        })),
      setKatbotUser: (user) =>
        set((state) => ({
          instance: { ...state.instance, katbotUser: user },
        })),
      clearKatbotSession: () =>
        set((state) => ({
          instance: { ...state.instance, katbotToken: null, katbotUser: null },
        })),
    }),
    {
      name: "katpack-instance",
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
      // Exclude Katbot session tokens from localStorage persistence
      partialize: (state) => ({
        _hasHydrated: state._hasHydrated,
        instance: {
          jwtToken: state.instance.jwtToken,
          refreshToken: state.instance.refreshToken,
          apiBaseUrl: state.instance.apiBaseUrl,
          userSub: state.instance.userSub,
        },
      }),
    }
  )
);
